import { useTranslation } from 'react-i18next';
import { Briefcase, Users, MoveRight, Plane, type LucideIcon } from 'lucide-react';

type Audience = {
  key: 'business' | 'family' | 'relocation' | 'international';
  Icon: LucideIcon;
};

const AUDIENCES: Audience[] = [
  { key: 'business', Icon: Briefcase },
  { key: 'family', Icon: Users },
  { key: 'relocation', Icon: MoveRight },
  { key: 'international', Icon: Plane },
];

export default function WhoWeServe() {
  const { t } = useTranslation();

  return (
    <section className="bg-bg px-6 py-20 md:px-10 md:py-24">
      <header className="mb-10 max-w-[680px]">
        <div className="mb-3 text-xs uppercase tracking-[0.12em] text-accent">
          ❋&nbsp;&nbsp;{t('whoWeServe.eyebrow')}
        </div>
        <h2 className="m-0 text-balance font-display font-semibold leading-[1.05] tracking-display text-ink [font-size:clamp(32px,4vw,52px)]">
          {t('whoWeServe.headline')}
        </h2>
      </header>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
        {AUDIENCES.map(({ key, Icon }) => (
          <article key={key} className="rounded-md border border-line bg-surface p-5">
            <Icon size={20} aria-hidden className="text-accent" />
            <h3 className="mt-4 font-display text-[16px] font-semibold tracking-display text-ink">
              {t(`whoWeServe.${key}.title`)}
            </h3>
            <p className="mt-1.5 text-[14px] leading-relaxed text-muted">
              {t(`whoWeServe.${key}.body`)}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
